<!-- 小猪班纳童装 - 品牌后台管理系统 -->
<template>
  <div class="login-page">
    <!-- 背景层 -->
    <div class="bg-layer">
      <!-- 云朵 -->
      <div class="cloud cloud-1"></div>
      <div class="cloud cloud-2"></div>
      <div class="cloud cloud-3"></div>
      <!-- 浮动气泡 -->
      <div class="bubble bubble-1"></div>
      <div class="bubble bubble-2"></div>
      <div class="bubble bubble-3"></div>
      <div class="bubble bubble-4"></div>
      <div class="bubble bubble-5"></div>
      <!-- 装饰圆 -->
      <div class="deco-circle c-1"></div>
      <div class="deco-circle c-2"></div>
      <div class="deco-circle c-3"></div>
    </div>

    <!-- 主容器 -->
    <div class="main-container">
      <!-- ===== 左侧品牌展示区（桌面端可见） ===== -->
      <div class="brand-panel">
        <div class="brand-inner">
          <!-- 浮动猪图标 -->
          <div class="hero-pig">
            <img src="../../assets/login.png" alt="" class="pig-img" />
          </div>
          <h1 class="brand-title">
            <span class="title-line">PEPCO</span>
            <span class="title-sub">Little Pig</span>
          </h1>
          <p class="brand-desc">Children's Fashion Wear</p>
          <div class="tag-row">
            <span class="tag">自由</span>
            <span class="tag">轻松</span>
            <span class="tag">舒适</span>
            <span class="tag">健康</span>
          </div>
          <!-- 装饰线 -->
          <div class="divider"><span></span></div>
          <p class="brand-motto">用爱编织童年 · 用心创造美好</p>
        </div>
      </div>

      <!-- ===== 右侧登录区 ===== -->
      <div class="login-panel">
        <div class="login-inner">
          <!-- 移动端 Logo -->
          <div class="mobile-logo">
            <img src="../../assets/login.png" alt="" class="ml-pig" />
            <span class="ml-name">PEPCO</span>
          </div>

          <h2 class="login-title">欢迎回来 👋</h2>
          <p class="login-sub">官网管理后台</p>

          <div class="form-area">
            <div class="input-group">
              <div class="input-wrap">
                <svg class="input-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                <input v-model="userInfo.username" type="text" placeholder="请输入账号" class="input-field" autocomplete="off" />
              </div>
            </div>

            <div class="input-group">
              <div class="input-wrap">
                <svg class="input-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <input v-model="userInfo.password" type="password" placeholder="请输入密码" class="input-field" @keyup.enter="login" />
              </div>
            </div>

            <button class="login-btn" @click="login">
              <span>登录</span>
              <svg class="btn-arrow-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>

          <p class="footer-note">
            <span class="dot"></span>
            广东小猪班纳服饰股份有限公司© 2020-{{ currentYear }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapActions } from 'vuex'

export default {
  name: 'AdminLogin',
  components: {},
  data() {
    return {
      userInfo: {
        username: '',
        password: ''
      },
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    ...mapActions(['Login']),
    login() {
      let _this = this
      if (!this.userInfo.username || !this.userInfo.password) {
        Message.error('请输入账号和密码')
        return
      }
      this.Login(this.userInfo).then(() => {
        _this.$router.replace({ name: 'ahome' }).then(() => {
          window.location.reload()
          Message.success('登录成功')
        }, () => {
          Message.error('登录失败，请重试')
        })
      }).catch((err) => {
        console.error('登录异常', err)
        const msg = (err && (err.message || '')) || '用户不存在或密码错误'
        const friendlyMsg = msg.indexOf('status code') > -1 || msg.indexOf('timeout') > -1
          ? '账号或密码错误，请重新输入！'
          : msg
        Message.error(friendlyMsg)
      })
    }
  },
  created() {
    localStorage.removeItem('pLogout')
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>

<style lang="scss" scoped>
// ==========================================
// 小猪班纳童装 · 品牌后台登录页
// ==========================================

// ---- 全局重置 ----
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #e3f2fd 0%, #bbdefb 25%, #e8f5e9 50%, #e1f5fe 75%, #e3f2fd 100%);
  position: relative;
  overflow: hidden;
  font-family: -apple-system, 'SF Pro Display', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}

// ---- 背景装饰层 ----
.bg-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

// 云朵
.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 80px;
  animation: cloudDrift linear infinite;

  &::before,
  &::after {
    content: '';
    position: absolute;
    background: inherit;
    border-radius: 50%;
  }
}
.cloud-1 {
  width: 180px; height: 55px;
  top: 8%; left: -100px;
  animation-duration: 28s;
  &::before { width: 50px; height: 50px; top: -28px; left: 35px; }
  &::after  { width: 70px; height: 70px; top: -38px; left: 75px; }
}
.cloud-2 {
  width: 140px; height: 42px;
  top: 18%; right: -80px;
  animation-duration: 34s; animation-delay: -8s;
  &::before { width: 40px; height: 40px; top: -22px; left: 25px; }
  &::after  { width: 55px; height: 55px; top: -30px; left: 55px; }
}
.cloud-3 {
  width: 200px; height: 60px;
  top: 60%; left: 60%;
  animation-duration: 38s; animation-delay: -15s;
  opacity: 0.5;
  &::before { width: 55px; height: 55px; top: -30px; left: 40px; }
  &::after  { width: 75px; height: 75px; top: -40px; left: 85px; }
}

@keyframes cloudDrift {
  0%   { transform: translateX(0) translateY(0); }
  25%  { transform: translateX(40px) translateY(-10px); }
  50%  { transform: translateX(80px) translateY(5px); }
  75%  { transform: translateX(40px) translateY(-5px); }
  100% { transform: translateX(0) translateY(0); }
}

// 气泡
.bubble {
  position: absolute;
  border-radius: 50%;
  animation: bubbleFloat ease-in-out infinite;
}
.bubble-1 { width:45px;height:45px; top:70%;left:10%; background:rgba(66,165,245,.12); animation-duration:7s;animation-delay:0s; }
.bubble-2 { width:30px;height:30px; top:40%;left:80%; background:rgba(129,212,250,.15); animation-duration:8s;animation-delay:-2s; }
.bubble-3 { width:55px;height:55px; top:20%;left:45%; background:rgba(79,195,247,.10); animation-duration:9s;animation-delay:-4s; }
.bubble-4 { width:25px;height:25px; top:80%;left:35%; background:rgba(41,182,246,.15); animation-duration:6s;animation-delay:-1s; }
.bubble-5 { width:38px;height:38px; top:10%;left:75%; background:rgba(66,165,245,.10); animation-duration:10s;animation-delay:-6s; }

@keyframes bubbleFloat {
  0%, 100% { transform: translateY(0) scale(1); opacity: 1; }
  50% { transform: translateY(-30px) scale(1.2); opacity: 0.6; }
}

// 装饰圆
.deco-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
}
.c-1 { width:350px;height:350px; background:#42a5f5; top:-100px; right:-80px; }
.c-2 { width:200px;height:200px; background:#29b6f6; bottom:-50px; left:-50px; }
.c-3 { width:120px;height:120px; background:#81d4fa; top:50%; left:50%; transform:translate(-50%,-50%); opacity:0.04; }

// ---- 主容器 ----
.main-container {
  position: relative;
  z-index: 2;
  display: flex;
  width: 920px;
  max-width: 95vw;
  min-height: 560px;
  border-radius: 28px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(24px);
  box-shadow:
    0 4px 6px rgba(100, 181, 246, 0.06),
    0 16px 48px rgba(33, 150, 243, 0.08),
    0 40px 80px rgba(33, 150, 243, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.5);
  animation: containerIn 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
}

@keyframes containerIn {
  0% { opacity: 0; transform: translateY(40px) scale(0.94); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

// ===== 左侧品牌展示区 =====
.brand-panel {
  flex: 0 0 48%;
  background: linear-gradient(160deg, #e3f2fd 0%, #bbdefb 30%, #c8e6f9 60%, #e1f5fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(255,255,255,0.4) 0%, transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(255,255,255,0.3) 0%, transparent 60%);
  }
}

.brand-inner {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 40px;
}

.hero-pig {
  width: 120px;
  height: 120px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.5));
  box-shadow:
    0 8px 32px rgba(33, 150, 243, 0.15),
    inset 0 1px 0 rgba(255,255,255,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pigFloat 4s ease-in-out infinite;

  .pig-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
}

@keyframes pigFloat {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-8px) rotate(-2deg); }
  75% { transform: translateY(-4px) rotate(2deg); }
}

.brand-title {
  margin: 0 0 8px;
  .title-line {
    display: block;
    font-size: 42px;
    font-weight: 900;
    letter-spacing: 8px;
    background: linear-gradient(135deg, #1565c0, #42a5f5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .title-sub {
    display: block;
    font-size: 15px;
    font-weight: 500;
    color: #78909c;
    letter-spacing: 6px;
    margin-top: 4px;
    text-transform: uppercase;
  }
}

.brand-desc {
  font-size: 14px;
  color: #90a4ae;
  letter-spacing: 3px;
  margin: 0 0 20px;
}

.tag-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;

  .tag {
    padding: 5px 16px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.7);
    color: #1565c0;
    letter-spacing: 2px;
    border: 1px solid rgba(66, 165, 245, 0.15);
    backdrop-filter: blur(4px);
    transition: all 0.3s;

    &:hover {
      background: rgba(66, 165, 245, 0.12);
      transform: translateY(-2px);
    }
  }
}

.divider {
  margin: 24px auto;
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(66,165,245,.4), transparent);
  border-radius: 1px;

  span {
    display: block;
    width: 6px;
    height: 6px;
    background: #42a5f5;
    border-radius: 50%;
    margin: -2px auto 0;
  }
}

.brand-motto {
  font-size: 13px;
  color: #90a4ae;
  letter-spacing: 1px;
  margin: 0;
  font-weight: 400;
}

// ===== 右侧登录区 =====
.login-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
}

.login-inner {
  width: 100%;
  max-width: 340px;
  padding: 48px 36px;
}

.mobile-logo {
  display: none;
}

.login-title {
  font-size: 26px;
  font-weight: 700;
  color: #1a237e;
  margin: 0 0 6px;
  letter-spacing: 1px;
}

.login-sub {
  font-size: 14px;
  color: #37474f;
  margin: 0 0 36px;
}

// ---- 表单 ----
.form-area {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  position: relative;
}

.input-wrap {
  position: relative;
  display: flex;
  align-items: center;

  .input-svg {
    position: absolute;
    left: 14px;
    z-index: 1;
    color: #90a4ae;
    transition: color 0.3s;
    pointer-events: none;
  }
}

.input-field {
  width: 100%;
  padding: 14px 16px 14px 44px;
  border: 2px solid #e3eef7;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  color: #37474f;
  outline: none;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.5px;

  &::placeholder {
    color: #b0bec5;
    font-size: 13px;
  }

  &:focus {
    border-color: #42a5f5;
    background: #fff;
    box-shadow:
      0 0 0 4px rgba(66, 165, 245, 0.08),
      0 2px 8px rgba(66, 165, 245, 0.06);

    & ~ .input-svg,
    & + .input-svg {
      color: #42a5f5;
    }
  }
}

// 当 input 聚焦时改变图标颜色（通过 sibling）
.input-field:focus ~ .input-svg {
  color: #42a5f5;
}
.input-field:focus + .input-svg {
  color: #42a5f5;
}

// ---- 登录按钮 ----
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 15px 0;
  margin-top: 6px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 4px 16px rgba(66, 165, 245, 0.25),
    0 1px 4px rgba(66, 165, 245, 0.15);

  // 按钮光泽
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 300%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent,
      rgba(255,255,255,0.2),
      transparent
    );
    transition: left 0.6s;
  }

  .btn-arrow-svg {
    transition: transform 0.3s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow:
      0 8px 28px rgba(66, 165, 245, 0.35),
      0 2px 8px rgba(66, 165, 245, 0.2);

    &::after {
      left: 100%;
    }

    .btn-arrow-svg {
      transform: translateX(4px);
    }
  }

  &:active {
    transform: translateY(0) scale(0.98);
    box-shadow:
      0 2px 8px rgba(66, 165, 245, 0.2);
    transition: all 0.1s;
  }
}

// ---- 底部 ----
.footer-note {
  text-align: center;
  margin-top: 28px;
  font-size: 11px;
  color: #90a4ae;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .dot {
    width: 4px;
    height: 4px;
    background: #81d4fa;
    border-radius: 50%;
    animation: dotPulse 2s ease-in-out infinite;
  }
}

@keyframes dotPulse {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.5); }
}

// ==========================================
// 响应式
// ==========================================
@media (max-width: 768px) {
  .main-container {
    flex-direction: column;
    width: 92vw;
    min-height: auto;
    border-radius: 24px;
  }

  .brand-panel {
    flex: none;
    padding: 32px 20px 20px;

    .brand-title .title-line { font-size: 32px; letter-spacing: 6px; }
    .brand-title .title-sub { font-size: 13px; letter-spacing: 4px; }
    .brand-desc { font-size: 12px; }
    .brand-motto { font-size: 11px; }
    .hero-pig {
      width: 90px; height: 90px;
      .pig-img { width: 60px; height: 60px; }
    }
    .tag-row {
      gap: 6px;
      .tag { padding: 4px 12px; font-size: 11px; }
    }
  }

  .login-panel {
    padding: 0;
  }

  .login-inner {
    padding: 28px 28px 36px;
  }

  .login-title { font-size: 22px; }
}

@media (max-width: 480px) {
  .main-container {
    width: 94vw;
    border-radius: 20px;
  }

  .brand-panel {
    padding: 24px 16px 16px;
    .hero-pig { width: 72px; height: 72px; margin-bottom: 16px;
      .pig-img { width: 48px; height: 48px; }
    }
    .brand-title .title-line { font-size: 26px; }
  }

  .login-inner {
    padding: 20px 20px 30px;
  }

  .login-title { font-size: 20px; }
  .login-sub { font-size: 13px; margin-bottom: 24px; }

  .input-field {
    padding: 12px 14px 12px 40px;
    font-size: 13px;
    border-radius: 12px;
  }

  .login-btn {
    padding: 13px 0;
    font-size: 15px;
    border-radius: 12px;
  }
}
</style>
